import { AppServiceSolutionCardDto } from "dto/components/app-services-solution-card-dto";

import cardBox from "assets/images/card-box.svg";

const AppServiceSolutionCard = ({ title, description }: AppServiceSolutionCardDto) => {
	const formattedDescription = description.replace(/-/g, "‑");
	
	return (
		<div className="app-service-solution-card">
			<div className="service-card">
				<div className="service-card__image" style={{ backgroundImage: `url(${cardBox})` }}>
					<div className="service-card__wrapper">
						<p className="service-card__title">{title}</p>

						<p className="service-card__description">{formattedDescription}</p>
					</div>
				</div>
			</div>
		</div>
	);
};

export default AppServiceSolutionCard;
